/**
 * Datenschutzerklärung.
 * Quelle: https://devhive.de/datenschutz.html — bei Änderungen dort
 * bitte hier nachziehen.
 */

import { Link } from 'react-router-dom';

export default function DatenschutzPage() {
  return (
    <div className="max-w-2xl mx-auto space-y-6 pb-8 text-slate-200">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">Datenschutzerklärung</h2>
        <Link to="/" className="text-xs text-slate-400 hover:text-slate-200 underline">
          ← zurück
        </Link>
      </div>

      <section>
        <h3 className="text-base font-semibold mb-2">1. Datenschutz auf einen Blick</h3>
        <h4 className="text-sm font-medium mt-2 mb-1">Allgemeine Hinweise</h4>
        <p className="text-sm text-slate-300">
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
          personenbezogenen Daten passiert, wenn Sie diese Website besuchen.
          Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert
          werden können.
        </p>

        <h4 className="text-sm font-medium mt-3 mb-1">
          Datenerfassung auf dieser Website
        </h4>
        <p className="text-sm font-medium text-slate-200 mt-2">
          Wer ist verantwortlich für die Datenerfassung auf dieser Website?
        </p>
        <p className="text-sm text-slate-300">
          Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber.
          Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
        </p>

        <p className="text-sm font-medium text-slate-200 mt-2">
          Wie erfassen wir Ihre Daten?
        </p>
        <p className="text-sm text-slate-300">
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen
          (z. B. über ein Kontaktformular oder Discord). Andere Daten werden automatisch
          beim Besuch der Website durch unsere IT-Systeme erfasst (z. B. Browsertyp,
          Betriebssystem, Uhrzeit des Zugriffs).
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold mb-2">2. Hosting</h3>
        <p className="text-sm text-slate-300">
          Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf
          dieser Website erfasst werden, werden auf den Servern des Hosters
          gespeichert. Hierbei kann es sich um IP-Adressen, Kontaktanfragen, Meta- und
          Kommunikationsdaten, Websitezugriffe und sonstige Daten handeln.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold mb-2">
          3. Allgemeine Hinweise und Pflichtinformationen
        </h3>

        <h4 className="text-sm font-medium mt-2 mb-1">Datenschutz</h4>
        <p className="text-sm text-slate-300">
          Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr
          ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend
          der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
        </p>

        <h4 className="text-sm font-medium mt-3 mb-1">
          Hinweis zur verantwortlichen Stelle
        </h4>
        <p className="text-sm text-slate-300">
          Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
        </p>
        <p className="text-sm text-slate-200 mt-2">
          DevHive Network<br />
          Tobias Peters<br />
          c/o Online-Impressum.de #53822<br />
          Europaring 90<br />
          53757 Sankt Augustin<br />
          Deutschland<br />
          E-Mail:{' '}
          <a href="mailto:admin@devhive.de" className="text-brand hover:underline">
            admin@devhive.de
          </a>
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold mb-2">
          4. Datenerfassung auf dieser Website
        </h3>

        <h4 className="text-sm font-medium mt-2 mb-1">Server-Log-Dateien</h4>
        <p className="text-sm text-slate-300 mb-2">
          Der Provider der Seiten erhebt und speichert automatisch Informationen in
          sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt:
        </p>
        <ul className="text-sm text-slate-300 list-disc list-inside space-y-0.5">
          <li>Browsertyp und Browserversion</li>
          <li>Verwendetes Betriebssystem</li>
          <li>Referrer URL</li>
          <li>Hostname des zugreifenden Rechners</li>
          <li>Uhrzeit der Serveranfrage</li>
          <li>IP-Adresse</li>
        </ul>
        <p className="text-sm text-slate-300 mt-2">
          Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
          vorgenommen.
        </p>

        <h4 className="text-sm font-medium mt-3 mb-1">Cookies</h4>
        <p className="text-sm text-slate-300">
          Diese Website verwendet keine Tracking-Cookies. Es werden ausschließlich
          technisch notwendige Cookies eingesetzt, sofern erforderlich.
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold mb-2">5. Externe Dienste</h3>
        <h4 className="text-sm font-medium mt-2 mb-1">Discord</h4>
        <p className="text-sm text-slate-300">
          Auf unserer Website verlinken wir auf unseren Discord-Server. Wenn Sie Discord
          nutzen, gelten die Datenschutzbestimmungen von Discord Inc. Weitere
          Informationen finden Sie unter:{' '}
          <a
            href="https://discord.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand hover:underline"
          >
            discord.com/privacy
          </a>
        </p>
      </section>

      <section>
        <h3 className="text-base font-semibold mb-2">6. Ihre Rechte</h3>
        <p className="text-sm text-slate-300">
          Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre
          gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den
          Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder
          Löschung dieser Daten.
        </p>
      </section>

      <p className="text-xs text-slate-500">Stand: Februar 2026</p>
    </div>
  );
}
